import { Attribution } from 'types'

interface Params {
  endDate: string
  startDate: string
  attr: Attribution
}

export const getTotalSum = ({ endDate, startDate, attr }: Params) => {
  const where = `WHERE stats.event_date <= '${endDate}' AND stats.event_date >= '${startDate}'`
  switch (attr) {
    case 'first':
      return `SELECT SUM(first.total_amount), SUM(first.recurring_payments_amount), SUM(first.orders_amount), SUM(first.ad_spend), SUM(stats.views), SUM(stats.new_visitors), SUM(first.leads), SUM(first.total_orders), SUM(first.form_submits), SUM(first.new_customers), SUM(first.sum_source_touches_at_lead), SUM(first.count_source_touches_at_lead), SUM(first.sum_source_touches_at_order), SUM(first.count_source_touches_at_order) FROM page ${where}`
    case 'last':
      return `SELECT SUM(last.total_amount), SUM(last.recurring_payments_amount), SUM(last.orders_amount), SUM(last.ad_spend), SUM(stats.views), SUM(stats.new_visitors), SUM(last.leads), SUM(last.total_orders), SUM(last.form_submits), SUM(last.new_customers), SUM(last.sum_source_touches_at_lead), SUM(last.count_source_touches_at_lead), SUM(last.sum_source_touches_at_order), SUM(last.count_source_touches_at_order) FROM page ${where}`
    case 'linear':
      return `SELECT SUM(linear_page.total_amount), SUM(linear_page.recurring_payments_amount), SUM(linear_page.orders_amount), SUM(linear_page.ad_spend), SUM(stats.views), SUM(stats.new_visitors), SUM(linear_page.leads), SUM(linear_page.total_orders), SUM(linear_page.form_submits), SUM(stats.new_customers) FROM page ${where}`
    case 'ai':
      return `SELECT SUM(ai_page.total_amount), SUM(ai_page.recurring_payments_amount), SUM(ai_page.orders_amount), SUM(ai_page.ad_spend), SUM(stats.views), SUM(stats.new_visitors), SUM(ai_page.leads), SUM(ai_page.total_orders), SUM(ai_page.form_submits), SUM(stats.new_customers) FROM page ${where}`
    default:
      return ''
  }
}
